import React, { useContext } from 'react';
import { getComponentName } from './helpers';

export const MatureContext = React.createContext(false);
MatureContext.displayName = 'MatureContext';

export type WithMatureContextProps = { showMatureContent?: boolean };

// HOC for convenience...
export function withMatureContext<TProps>(
  Component: React.ComponentType<TProps & WithMatureContextProps>
) {
  const DecoratedComponent: React.FC<TProps> = props => {
    const showMatureContent = useContext(MatureContext);
    return <Component showMatureContent={showMatureContent} {...props} />;
  };
  DecoratedComponent.displayName = `withMatureContext(${getComponentName(
    Component
  )})`;
  return DecoratedComponent;
}
